(function () {
    function initGsStoryPopIn() {
      const sections = document.querySelectorAll(".gs-story-section");

      if (!sections.length) {
        return;
      }

      const reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches;

      sections.forEach(function (section) {
        if (section.dataset.gsStoryPopReady === "true") {
          return;
        }

        section.dataset.gsStoryPopReady = "true";

        if (reducedMotion) {
          section.classList.add("is-visible");
          return;
        }

        section.classList.add("gs-story-animate-ready");

        if (!("IntersectionObserver" in window)) {
          section.classList.add("is-visible");
          return;
        }

        const observer = new IntersectionObserver(
          function (entries, currentObserver) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add("is-visible");
                currentObserver.unobserve(entry.target);
              }
            });
          },
          {
            threshold: 0.16,
            rootMargin: "0px 0px -6% 0px"
          }
        );

        observer.observe(section);
      });
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initGsStoryPopIn);
    } else {
      initGsStoryPopIn();
    }

    document.addEventListener("shopify:section:load", initGsStoryPopIn);
  })();
